import { render, staticRenderFns } from "./NoticeHeader.vue?vue&type=template&id=18c6612d&scoped=true&"
import script from "./NoticeHeader.vue?vue&type=script&lang=ts&"
export * from "./NoticeHeader.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeHeader.vue?vue&type=style&index=0&id=18c6612d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6612d",
  null
  
)

export default component.exports